import Swal from "sweetalert2";

export default {
  open_profile_assignment(form) {
    this.profile_assignment_form = form;
    const assigned_names = form.assigned_profile_types || [];
    this.selected_profile_ids = this.profile_types
      .filter(profile => assigned_names.includes(profile.name))
      .map(profile => profile.id);
    this.initial_profile_ids = [...this.selected_profile_ids];
  },
  close_profile_assignment() {
    this.profile_assignment_form = null;
    this.selected_profile_ids = [];
    this.initial_profile_ids = [];
  },
  async save_profile_assignment() {
    if (!this.profile_assignment_form?.id || this.saving_profile_assignment) return;
    const added = this.selected_profile_ids.filter(id => !this.initial_profile_ids.includes(id));
    const removed = this.initial_profile_ids.filter(id => !this.selected_profile_ids.includes(id));

    if (!added.length && !removed.length) {
      Swal.fire({ icon: "info", title: "No assignment changes", toast: true,
        position: "bottom-end", timer: 1600, showConfirmButton: false });
      return;
    }

    this.saving_profile_assignment = true;
    try {
      if (removed.length) await this.post_profile_assignment("unassign_profile_question", removed);
      if (added.length) await this.post_profile_assignment("assign_profile_question", added);
      this.profile_assignment_form.assigned_profile_types = this.profile_types
        .filter(profile => this.selected_profile_ids.includes(profile.id))
        .map(profile => profile.name);
      this.close_profile_assignment();
      Swal.fire({ icon: "success", title: "Form assigned to personal profiles", toast: true,
        position: "bottom-end", timer: 2000, showConfirmButton: false });
    } catch {
      Swal.fire({ icon: "error", title: "Unable to save profile assignments" });
    } finally {
      this.saving_profile_assignment = false;
    }
  },
  post_profile_assignment(endpoint, profile_ids) {
    return $.ajax({
      url: `${process.env.VUE_APP_BACKEND_API_URL}/system_management/${endpoint}/`,
      method: "POST",
      headers: this.get_json_headers(),
      data: JSON.stringify({
        form_id: this.profile_assignment_form.id,
        profile_type_ids: profile_ids,
        portal_ids: [],
        business_tab: "",
      }),
    });
  },
};
